var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';
var WeblinkEntryComponent = /** @class */ (function () {
    function WeblinkEntryComponent(toastr) {
        this.toastr = toastr;
        this.weblinkEvent = new EventEmitter();
        this.listWeblink = false;
        this.listWeblinkData = [];
        this.faLink = faLink;
        this.weblinkData = [];
        this.webLink = '';
        this.viewModel = {
            errorText: '',
            weblinkEntryText: 'In addition to any documentation you add, or as an alternative, you can provide web links to relevant information',
            weblinksChanged: new EventEmitter(),
        };
        this.componentTitle = this.viewModel.weblinkEntryText;
    }
    WeblinkEntryComponent.prototype.addWeblink = function () {
        if (this.weblinkData.length >= 5) {
            this.toastr.error('A maximum of 5 web links are allowed', 'Error!', {
                timeOut: 3000,
                positionClass: 'toast-bottom-right'
            });
        }
        var uRe = this.webLink;
        var urlRegex = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*(\/)?([da-z0-9_\-#\/\?&=])*?$/gi;
        if (urlRegex.test(uRe)) {
            this.weblinkData.push(this.webLink);
            this.weblinkEvent.emit(this.weblinkData);
            this.webLink = '';
            this.toastr.success('Weblink added', 'Success!', {
                timeOut: 2000,
                positionClass: 'toast-bottom-right'
            });
        }
        else {
            this.toastr.error('Please make sure your web link is correct', 'Error!', {
                timeOut: 3000,
                positionClass: 'toast-bottom-right'
            });
        }
    };
    WeblinkEntryComponent.prototype.removeWeblink = function (i, $event) {
        if (this.weblinkData.length >= 1) {
            this.weblinkData.splice(i, 1);
            this.toastr.success('Weblink removed', 'Success!', {
                timeOut: 2000,
                positionClass: 'toast-bottom-right'
            });
        }
        this.weblinkEvent.emit(this.weblinkData);
    };
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], WeblinkEntryComponent.prototype, "weblinkEvent", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], WeblinkEntryComponent.prototype, "componentTitle", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], WeblinkEntryComponent.prototype, "listWeblink", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], WeblinkEntryComponent.prototype, "listWeblinkData", void 0);
    WeblinkEntryComponent = __decorate([
        Component({
            selector: 'weblink-entry',
            template: require('./weblink-entry.component.html'),
            styles: [require('./weblink-entry.component.scss')]
        }),
        __metadata("design:paramtypes", [ToastrService])
    ], WeblinkEntryComponent);
    return WeblinkEntryComponent;
}());
export { WeblinkEntryComponent };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid2VibGluay1lbnRyeS5jb21wb25lbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ3ZWJsaW5rLWVudHJ5LmNvbXBvbmVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSxPQUFPLEVBQUUsU0FBUyxFQUFFLFlBQVksRUFBRSxLQUFLLEVBQUUsTUFBTSxFQUFFLE1BQU0sZUFBZSxDQUFDO0FBQ3ZFLE9BQU8sRUFBRSxNQUFNLEVBQUUsTUFBTSxtQ0FBbUMsQ0FBQztBQUkzRCxPQUFPLEVBQUUsYUFBYSxFQUFFLE1BQU0sWUFBWSxDQUFDO0FBTzNDO0lBU0ksK0JBQW9DLE1BQXFCO1FBQXJCLFdBQU0sR0FBTixNQUFNLENBQWU7UUFSeEMsaUJBQVksR0FBRyxJQUFJLFlBQVksRUFBUyxDQUFDO1FBRTFDLGdCQUFXLEdBQVksS0FBSyxDQUFDO1FBQzdCLG9CQUFlLEdBQWEsRUFBRSxDQUFDO1FBR3hDLFdBQU0sR0FBRyxNQUFNLENBQUM7UUFXaEIsZ0JBQVcsR0FBYSxFQUFFLENBQUM7UUFDM0IsWUFBTyxHQUFXLEVBQUUsQ0FBQztRQVR4QixJQUFJLENBQUMsU0FBUyxHQUFHO1lBQ2IsU0FBUyxFQUFFLEVBQUU7WUFDYixnQkFBZ0IsRUFBRSxtSEFBbUg7WUFDckksZUFBZSxFQUFFLElBQUksWUFBWSxFQUFPO1NBQzNDLENBQUM7UUFDRixJQUFJLENBQUMsY0FBYyxHQUFHLElBQUksQ0FBQyxTQUFTLENBQUMsZ0JBQWdCLENBQUM7SUFDMUQsQ0FBQztJQUtNLDBDQUFVLEdBQWpCO1FBQ0ksSUFBSSxJQUFJLENBQUMsV0FBVyxDQUFDLE1BQU0sSUFBSSxDQUFDLEVBQUU7WUFDOUIsSUFBSSxDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUMsc0NBQXNDLEVBQUUsUUFBUSxFQUFFO2dCQUNoRSxPQUFPLEVBQUUsSUFBSTtnQkFDYixhQUFhLEVBQUUsb0JBQW9CO2FBQ3RDLENBQUMsQ0FBQztTQUNOO1FBQ0QsSUFBTSxHQUFHLEdBQVcsSUFBSSxDQUFDLE9BQU8sQ0FBQztRQUNqQyxJQUFNLFFBQVEsR0FBVywyRkFBMkYsQ0FBQztRQUNySCxJQUFJLFFBQVEsQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLEVBQUU7WUFDcEIsSUFBSSxDQUFDLFdBQVcsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxDQUFDO1lBQ3BDLElBQUksQ0FBQyxZQUFZLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxXQUFXLENBQUMsQ0FBQztZQUN6QyxJQUFJLENBQUMsT0FBTyxHQUFHLEVBQUUsQ0FBQztZQUVsQixJQUFJLENBQUMsTUFBTSxDQUFDLE9BQU8sQ0FBQyxlQUFlLEVBQUUsVUFBVSxFQUFFO2dCQUM3QyxPQUFPLEVBQUUsSUFBSTtnQkFDYixhQUFhLEVBQUUsb0JBQW9CO2FBQ3RDLENBQUMsQ0FBQztTQUVOO2FBQU07WUFDSCxJQUFJLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQywyQ0FBMkMsRUFBRSxRQUFRLEVBQUU7Z0JBQ3JFLE9BQU8sRUFBRSxJQUFJO2dCQUNiLGFBQWEsRUFBRSxvQkFBb0I7YUFDdEMsQ0FBQyxDQUFDO1NBQ047SUFDTCxDQUFDO0lBRU0sNkNBQWEsR0FBcEIsVUFBcUIsQ0FBUyxFQUFFLE1BQU07UUFDbEMsSUFBSSxJQUFJLENBQUMsV0FBVyxDQUFDLE1BQU0sSUFBSSxDQUFDLEVBQUU7WUFDOUIsSUFBSSxDQUFDLFdBQVcsQ0FBQyxNQUFNLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDO1lBQzlCLElBQUksQ0FBQyxNQUFNLENBQUMsT0FBTyxDQUFDLGlCQUFpQixFQUFFLFVBQVUsRUFBRTtnQkFDL0MsT0FBTyxFQUFFLElBQUk7Z0JBQ2IsYUFBYSxFQUFFLG9CQUFvQjthQUN0QyxDQUFDLENBQUM7U0FDTjtRQUNELElBQUksQ0FBQyxZQUFZLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxXQUFXLENBQUMsQ0FBQztJQUM3QyxDQUFDO0lBeERTO1FBQVQsTUFBTSxFQUFFOzsrREFBaUQ7SUFDakQ7UUFBUixLQUFLLEVBQUU7O2lFQUErQjtJQUM5QjtRQUFSLEtBQUssRUFBRTs7OERBQXFDO0lBQ3BDO1FBQVIsS0FBSyxFQUFFOztrRUFBdUM7SUFKdEMscUJBQXFCO1FBTGpDLFNBQVMsQ0FBQztZQUNQLFFBQVEsRUFBRSxlQUFlO1lBQ3pCLFFBQVEsRUFBRSxPQUFPLENBQUMsZ0NBQWdDLENBQUM7WUFDbkQsTUFBTSxFQUFFLENBQUMsT0FBTyxDQUFDLGdDQUFnQyxDQUFDLENBQUM7U0FDdEQsQ0FBQzt5Q0FVOEMsYUFBYTtPQVRoRCxxQkFBcUIsQ0EwRGpDO0lBQUQsNEJBQUM7Q0FBQSxBQTFERCxJQTBEQztTQTFEWSxxQkFBcUIifQ==